export enum RakebackErrors {
  notAvailable = 'Withdrawal not available',
  noTokens = 'No tokens to collect',
}
